import { FC } from 'react'
import { SideBarAvatar } from './SideBarAvatar'

export type SideBarPreviewProps = {
  cover: string
  avatar?: string
  title?: string
  children?: React.ReactNode
}
export const SideBarPreview: FC<SideBarPreviewProps> = ({
  cover,
  avatar,
  title,
  children,
}) => {
  return (
    <div className="max-w-80 ">
      <div className="relative w-80">
        <div className="h-32 w-80">
          {cover && (
            <img
              src={cover}
              alt="cover"
              className="h-full w-full object-cover"
            />
          )}
        </div>
        {title && <SideBarAvatar src={avatar} title={title} />}
      </div>
      {children}
    </div>
  )
}
